import React, { useContext, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
// import { useGetSpecificUserQuery } from "../../../Redux/service/Users/Users";
import trans from "../../../../utils";
import PermissionsBody from "./PermissionsBody";
import FormHeader from "../../../Helpers/Form/FormParts/FormHeader";
import Form from "../../../Helpers/Form/Form";
import { popupcontext } from "../../../../context/Popupscontext";

export default function PermissionsForm({ onSuccess }) {
	const { form, isEditing, currentUserId } = useContext(popupcontext);
	// const { refetch, data: userDetails } = useGetSpecificUserQuery(
	// 	currentUserId,
	// 	{ skip: !currentUserId }
	// );
	// useEffect(() => {
	// 	if (isEditing && currentUserId) {
	// 		refetch();
	// 	}
	// }, [currentUserId, isEditing, userDetails, refetch]);

	return (
		<>
			<Form show={form}>
				<Offcanvas.Header>
					<FormHeader
						title={
							isEditing ? trans("Edit permission") : trans("Add new permission")
						}
					/>
				</Offcanvas.Header>
				<div className="H-line"></div>
				<Offcanvas.Body>
					<PermissionsBody />
				</Offcanvas.Body>
			</Form>
		</>
	);
}
